module.exports = __webpack_public_path__ + "assets/img/4_306_big.d0185a03.jpg";